<template>
  <div>
    <loading-page
      :show-loading-page="showLoadingPage"
      :loading-message="loadingMessage"
    />
  </div>
</template>
<script>
import axios from 'src/app-axios';
import LoadingPage from 'src/views/components/LoadingPage.vue';

export default {
    name: 'Logout',
    components: {
      'loading-page': LoadingPage,
    },

    data () {
      return {
        showLoadingPage: false,
        loadingMessage: '',
      };
    },
    mounted () {
      this.showLoadingPage = true;
      this.loadingMessage = 'Logging Off...';
      setTimeout(() => {
       this.logOut();
      }, 2000);
    },
    methods: {
      async logOut () {
        await axios.post('api/devices/logout').then(() => {
            this.$store.dispatch('logout');
            this.$router.push({ name: 'HomePage' });
        }).catch(() => {
            this.$store.dispatch('logout');
            this.$router.push({ name: 'HomePage' });
        });
      },
    },
};
</script>
